import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { AddApplicationNoteRequest } from '@nucleus-commerce/api-client/platform';

import { applicationsApi } from '../api/applications-api';

import { applicationKeys } from './application-keys';

export function useAddApplicationNote(id: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: AddApplicationNoteRequest) => applicationsApi.addNote(id, body),
    meta: { successMessage: 'applications:toasts.noteAdded' },
    onSuccess: (application) => {
      queryClient.setQueryData(applicationKeys.detail(id), application);
    },
  });
}
